module.exports = __webpack_public_path__ + "img/ic-amexcard.db06e609.svg";